import React, { useState } from 'react';
import { Box, Toolbar, useTheme, useMediaQuery, Container } from '@mui/material';
import AppHeader from './AppHeader';
import AppDrawer from './AppDrawer';

interface MainLayoutProps {
  children: React.ReactNode;
}

const MainLayout: React.FC<MainLayoutProps> = ({ children }) => {
  const [drawerOpen, setDrawerOpen] = useState(false);
  const theme = useTheme();
  const isDesktop = useMediaQuery(theme.breakpoints.up('lg'));
  const drawerVariant: 'persistent' | 'temporary' = isDesktop ? 'persistent' : 'temporary';

  const handleDrawerToggle = () => {
    setDrawerOpen(prev => !prev);
  };

  const handleDrawerClose = () => {
    setDrawerOpen(false);
  };

  const drawerWidth = 240;

  return (
    <Box sx={{ display: 'flex', minHeight: '100vh', bgcolor: 'background.default' }}>
      <AppHeader onMenuToggle={handleDrawerToggle} />

      <AppDrawer
        open={drawerOpen}
        onClose={handleDrawerClose}
        width={drawerWidth}
        variant={drawerVariant}
      />

      <Box
        component='main'
        sx={{
          flexGrow: 1,
          ml: isDesktop && drawerOpen ? `${drawerWidth}px` : 0,
          transition: theme.transitions.create(['margin'], {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.enteringScreen,
          }),
        }}
      >
        <Toolbar />
        {/* Content width control */}
        <Container
          // maxWidth="md"
          sx={{
            px: { xs: 1.5, sm: 2, md: 1 },
            pb: { xs: 2, sm: 3 },
          }}
        >
          {children}
        </Container>
      </Box>
    </Box>
  );
};

export default MainLayout;
